import { $$ } from "./../OO_jquery";
import { getOrders } from "../../api/services/userService.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { DateTime } from "luxon";
import { logger } from "../../api/Logger";
export default {
  computed: {
    ...mapGetters([
      "user",
      "dbuser",
      "currencySign",
      "viewConfig",
      "dbuser",
      "currentStoreDoc",
    ]),
    showStampCircle() {
      return this.viewConfig && this.viewConfig.ViewStamp;
    },
    storeId() {
      return this.currentStoreDoc && this.currentStoreDoc.HQCompanyID;
    },
    userId() {
      const customerMemberCode = this.dbuser
        ? `${this.dbuser.CustomerMemberCode}`
        : "";
      return customerMemberCode;
    },
    isIos() {
      const isIos =
        navigator &&
        (!!navigator.platform.match(/iPhone|iPod|iPad/) ||
          !!navigator.platform.match(/Mac68K|MacPPC|MacIntel/));
      return isIos;
    },
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    ...mapActions(["updateUserPoints"]),
    updateStatus(status) {
      this.showProgress = status;
    },
    formatPagination() {
      this.$nextTick(() => {
        $$(".VuePagination__pagination-item-prev-page a").text(
          this.$t("message.previous")
        );
        $$(".VuePagination__pagination-item-next-page a").text(
          this.$t("message.next")
        );
      });
    },
    async initOrders(storeid) {
      var that = this;
      getOrders(this.user.id, storeid)
        .get()
        .then(
          (collection) => {
            if (!collection.empty) {
              that.orders.length = 0;
              that.pageOrders.length = 0;
              collection.forEach((doc) => {
                that.orders.push(doc.data());
              });
              that.orders = that.orders.filter(
                (p) =>
                  (p.RedeemPoints > 0 || p.RewardPoints > 0) &&
                  p.OrderNumber > 0
              );
              that.records = that.orders.length;
              that.formatPagination();
              for (
                let index = 0;
                index <
                (that.perPage < that.orders.length
                  ? that.perPage
                  : that.orders.length);
                index++
              ) {
                const element = that.orders[index];
                that.pageOrders.push(element);
              }
            }
          },
          function (reason) {
            logger.log(
              reason.code,
              reason.message,
              that.$router.currentRoute.fullPath
            );
          }
        );
    },
    paginateCallback(pageNumber) {
      this.pageOrders = [];
      let start = (pageNumber - 1) * this.perPage;
      let end = start + this.perPage;
      while (end > this.orders.length) {
        end--;
      }
      for (let index = start; index < end; index++) {
        const element = this.orders[index];
        this.pageOrders.push(element);
      }
    },
    moreCallback() {
      let start = (this.page - 1) * this.perPage;
      let end = start + this.perPage;
      while (end > this.orders.length) {
        end--;
      }
      for (let index = start; index < end; index++) {
        const element = this.orders[index];
        this.pageOrders.push(element);
      }
      this.page++;
    },
    getCreateDate(order) {
      if (order.CreatedOn)
        return DateTime.fromJSDate(
          new Date(order.CreatedOn.seconds * 1000)
        ).toFormat("ff");
    },
    shapeStyles() {
      var styles = [];
      styles.push(this.mobileStyles.CommonColorTxt);

      var circleContainer = document.getElementById("circleContainer");
      if (circleContainer) {
        styles.push({ left: circleContainer.offsetLeft + 120 + "px" });
        styles.push({ top: circleContainer.offsetTop + 43 + "px" });
      }
      return styles;
    },
    getDetStyles() {
      var styles = [];

      var circleContainer = document.getElementById("circleContainer");
      if (circleContainer) {
        styles.push({ position: "absolute" });
        styles.push({ left: circleContainer.offsetLeft + 128 + "px" });
        styles.push({ top: circleContainer.offsetTop + 148 + "px" });
      }
      return styles;
    },
    drawCircle(commonColor) {
      if (this.getFirstValidRedemptionRule) {
        let c = document.getElementById("circleContainer");
        if (!c) return;
        let ctx2 = c.getContext("2d");
        ctx2.beginPath();
        ctx2.lineWidth = 10;
        ctx2.strokeStyle = "#e9e9e9";
        ctx2.arc(
          168,
          75,
          70,
          (3 * Math.PI) / 5,
          (3 * Math.PI) / 5 + 2 * Math.PI * 0.89
        );
        ctx2.stroke();

        let ctx = c.getContext("2d");
        ctx.lineWidth = 10;
        ctx.strokeStyle = commonColor;
        ctx.beginPath();
        let ratio =
          (this.dbuser.RewardPoints ? this.dbuser.RewardPoints : 0) /
          this.getFirstValidRedemptionRule.Point;
        if (ratio > 1) ratio = 1;
        let endPoint = (3 * Math.PI) / 5 + 2 * Math.PI * ratio * 0.89;
        ctx.arc(168, 75, 70, (3 * Math.PI) / 5, endPoint);
        ctx.stroke();
      }
    },
    drawCircleMobile(commonColor) {
      if (this.getFirstValidRedemptionRule) {
        let c = document.getElementById("circleContainer");
        if (!c) return;
        let ctx2 = c.getContext("2d");
        ctx2.beginPath();
        ctx2.lineWidth = 10;
        ctx2.strokeStyle = "#e9e9e9";
        ctx2.arc(
          145,
          75,
          70,
          (3 * Math.PI) / 5,
          (3 * Math.PI) / 5 + 2 * Math.PI * 0.89
        );
        ctx2.stroke();

        let ctx = c.getContext("2d");
        ctx.lineWidth = 10;
        ctx.strokeStyle = commonColor;
        ctx.beginPath();
        let ratio =
          (this.dbuser.RewardPoints ? this.dbuser.RewardPoints : 0) /
          this.getFirstValidRedemptionRule.Point;
        if (ratio > 1) ratio = 1;
        let endPoint = (3 * Math.PI) / 5 + 2 * Math.PI * ratio * 0.89;
        ctx.arc(145, 75, 70, (3 * Math.PI) / 5, endPoint);
        ctx.stroke();
      }
    },
  },
};
